import useEventListener from "./useEventListener";

function useClickAnywhere(handler: (event: Event) => void) {
  useEventListener("click", (event) => {
    handler(event);
  });
}

export default useClickAnywhere;
